import Modal from './modal';

class LocationModalSlider {
  constructor() {
    this.triggers = document.querySelectorAll('.js__modal-trigger');
    this.slides = Array.from(document.querySelectorAll('.block-form__modal-slide'));
    this.sliderContainer = document.querySelector('.block-form__modal-slider');
    this.prevBtnGlobal = this.sliderContainer ? this.sliderContainer.querySelector('.block-form__modal-prev') : null;
    this.nextBtnGlobal = this.sliderContainer ? this.sliderContainer.querySelector('.block-form__modal-next') : null;

    this.isModalOpen = false;

    if (this.triggers.length > 0 && this.slides.length > 0 && this.prevBtnGlobal && this.nextBtnGlobal) {
      this.setupTriggers();
      this.setupModalListeners();
      document.addEventListener('keydown', this.handleKeyboardEvent.bind(this));
    }
  }

  setupTriggers() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', this.handleTriggerClick.bind(this));
    });
  }

  async handleTriggerClick(e) {
    e.preventDefault();
    const trigger = e.currentTarget;
    const id = trigger.dataset.modalId;
    const startIndex = this.slides.findIndex(s => s.dataset.modalId === id);
    if (startIndex === -1) return;

    await Modal.show(null, {
      modalClass: 'modal modal-location-slider'
    });

    this.isModalOpen = true;

    Modal.modalEl.appendChild(this.prevBtnGlobal);
    Modal.modalEl.appendChild(this.nextBtnGlobal);

    this.renderSlideContent(startIndex);
  }

  renderSlideContent(index) {
    const slide = this.slides[index];
    if (!slide) return;

    const clone = slide.cloneNode(true);
    const contentHTML = `<div class="modal__slide-wrapper">${clone.outerHTML}</div>`;

    Modal.setContent(contentHTML);
    Modal.setLoading(false);

    const newPrevIndex = (index - 1 + this.slides.length) % this.slides.length;
    const newNextIndex = (index + 1) % this.slides.length;

    this.prevBtnGlobal = this.reassignListener(this.prevBtnGlobal, newPrevIndex);
    this.nextBtnGlobal = this.reassignListener(this.nextBtnGlobal, newNextIndex);
  }

  reassignListener(oldButton, newIndex) {
    const newButton = oldButton.cloneNode(true);
    oldButton.parentNode.replaceChild(newButton, oldButton);

    newButton.addEventListener('click', e => {
      e.stopPropagation();
      this.renderSlideContent(newIndex);
    });

    return newButton;
  }

  setupModalListeners() {
    if (Modal.modalEl) {
        Modal.modalEl.addEventListener('hidden.bs.modal', () => { 
            this.isModalOpen = false;
            if (this.sliderContainer) {
                this.sliderContainer.appendChild(this.prevBtnGlobal);
                this.sliderContainer.appendChild(this.nextBtnGlobal);
            }
        });
    }
  }

  handleKeyboardEvent(e) {
    if (!this.isModalOpen) return;

    if (e.key === 'Escape') {
      Modal.hide();
      this.isModalOpen = false;
      return;
    }

    let buttonToActivate = null;

    if (e.key === 'ArrowRight') {
      e.preventDefault();
      buttonToActivate = this.nextBtnGlobal;
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      buttonToActivate = this.prevBtnGlobal;
    }

    if (buttonToActivate) {
        buttonToActivate.classList.add('keyboard-active');
        buttonToActivate.click();
        
        setTimeout(() => {
            buttonToActivate.classList.remove('keyboard-active');
        }, 1);
    }
  }
}

export default LocationModalSlider;